import { useContext } from "react";
import { AppContext } from "../../../providers";
import { get } from "lodash";
import { SocialNetwork } from "../../../interfaces";

export interface UserContextData {
  isPlayer: boolean;
  isCoach: boolean;
  isAssistantCoach: boolean;
  hasWritePermission: boolean;
  playerId?: number;
  coachId?: number;
  socialNetworks?: SocialNetwork[];
}

export const InitialUserContextData: UserContextData = {
  isPlayer: false,
  isCoach: false,
  isAssistantCoach: false,
  hasWritePermission: false,
  playerId: undefined,
  coachId: undefined,
  socialNetworks: undefined,
};

export const UserContext = (): UserContextData => {
  const { userContext } = useContext(AppContext);
  const isPlayer = !!userContext?.player;
  const isCoach = !!userContext?.coach;
  const isAssistantCoach = isCoach && !!userContext.isAssistant;
  var hasWritePermission = true;
  if (isAssistantCoach) {
    const playerCardPermission = userContext?.permissions?.find(el => el.componentId === "PLAYER_CARDS");
    if (playerCardPermission?.level !== "WRITE") {
      hasWritePermission = false;
    }
  }
  const socialNetworks = userContext?.profile?.socialNetworks;

  const playerId = userContext?.player?.id;
  var coachId: number | undefined;
  if (isCoach) coachId = Number(userContext?.coach?.id);
  else if (isPlayer) coachId = Number(get(userContext, "subscriptions[0].pricePlan.coachId"));

  return {
    isPlayer,
    isCoach,
    isAssistantCoach,
    hasWritePermission,
    playerId,
    coachId,
    socialNetworks,
  };
};
